export default __webpack_public_path__ + "static/media/18.8a0fe200.png";